import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    scroll-behavior: smooth;
  }
  body {
    font-family: 'Arial', sans-serif;
    background: ${(props) => props.theme.background};
    color: ${(props) => props.theme.text};
  }
`;

export default GlobalStyles;
